// 카드사 앱카드(card-pay) 결제 공통 유틸 — redirect 방식 (소켓 미사용)
//
// 흐름: (티켓) 결제 전 주문 데이터를 moid 키로 localStorage 저장 → card-pay로 전체 이동
//      → 카드앱 결제 → returnCardPay → (MallReserved=web 이면) 프론트 /payment/result 로 redirect
//      → 결과페이지가 저장된 데이터로 예매 생성(postOrder).
//      (마니아) 활성화는 returnCardPay(서버)에서 처리되므로 결과페이지는 완료 표시/유저 갱신만.

const STORAGE_PREFIX = 'cardpay:'

// 쿼리 파라미터를 encodeURIComponent 로 직렬화해 card-pay URL 을 만든다.
export function buildCardPayUrl(baseUrl, params) {
  const query = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value ?? '')}`)
    .join('&')
  return `${baseUrl}?${query}`
}

// 결제 전 주문 데이터를 moid 키로 저장 (전체 이동으로 SPA 메모리가 사라지므로 결과페이지에서 복원)
export function saveCardPayContext(moid, context) {
  try {
    localStorage.setItem(STORAGE_PREFIX + moid, JSON.stringify(context))
  } catch (e) {
    console.error('카드결제 컨텍스트 저장 실패', e)
  }
}

export function loadCardPayContext(moid) {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + moid)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function clearCardPayContext(moid) {
  try {
    localStorage.removeItem(STORAGE_PREFIX + moid)
  } catch (e) {
    // ignore
  }
}
